import { render, staticRenderFns } from "./appBarMessenger.vue?vue&type=template&id=2e9c635a"
import script from "./appBarMessenger.vue?vue&type=script&lang=ts"
export * from "./appBarMessenger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports